import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
export const DocsBlockContextPropertyConnectionValues = [
    "cursor",
    "claudeCode",
    "vsCode",
    "codex",
    "codeSnippet",
    "url",
];
export class DocsBlockContextPropertyDefinition extends DocsBlockPropertyDefinition {
}
